import React from 'react';

export const Relatorios = ({
  calcularClassesVencedoras,
  attendanceData,
  ordemTurmasRelatorio,
  setCurrentView,
  selectedDate,
  setSelectedDate,
  loadDashboard,
  isSunday
}) => {
  const classesVencedoras = calcularClassesVencedoras();

  // Aplicar ordenação personalizada aos dados dos relatórios
  const attendanceDataOrdenado = React.useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return [];

    const dadosOrdenados = [...attendanceData].sort((a, b) => {
      const indexA = ordemTurmasRelatorio.indexOf(a.turma_nome);
      const indexB = ordemTurmasRelatorio.indexOf(b.turma_nome);

      // Se não encontrar na lista, coloca no final
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });

    return dadosOrdenados;
  }, [attendanceData, ordemTurmasRelatorio]);

  const formatarPorcentagem = (valor) => {
    return isNaN(valor) ? '0,00' : valor.toFixed(2).replace('.', ',');
  };

  const formatarValor = (valor) => {
    return isNaN(valor) ? '0,00' : valor.toFixed(2).replace('.', ',');
  };

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <button
            onClick={() => setCurrentView('dashboard')}
            className="mb-4 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            ← Voltar ao Dashboard
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Relatórios Detalhados</h1>
          <p className="text-gray-600">Relatório consolidado e classes vencedoras por departamento</p>
        </div>

        {/* Controles de Data */}
        <div className="bg-white rounded-lg shadow-lg p-4 md:p-6 mb-6">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 space-y-4 md:space-y-0">
            <h2 className="text-xl font-semibold text-gray-800">Relatório do Dia</h2>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                onClick={loadDashboard}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Atualizar
              </button>
            </div>
          </div>

          {!isSunday(selectedDate) && (
            <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-4">
              <strong>Aviso:</strong> A data selecionada não é um domingo.
            </div>
          )}

          {/* Tabela de Consolidação */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-200 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-left">Turma</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Matric.</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Pres.</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">%</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Aus.</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Vis.</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Pós</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Ofertas</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Bíb.</th>
                  <th className="border border-gray-300 px-2 md:px-4 py-2 text-center">Rev.</th>
                </tr>
              </thead>
              <tbody>
                {attendanceDataOrdenado.map((row, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 md:px-4 py-2 font-medium">{row.turma_nome}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.matriculados}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.presentes}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center font-semibold text-purple-600">
                      {row.matriculados > 0 ? ((row.presentes / row.matriculados) * 100).toFixed(1).replace('.', ',') : '0,0'}%
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.ausentes}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.visitantes}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.pos_chamada}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">R$ {row.total_ofertas.toFixed(2).replace('.', ',')}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.total_biblias}</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">{row.total_revistas}</td>
                  </tr>
                ))}
                {attendanceDataOrdenado.length > 0 && (
                  <tr className="bg-blue-50 font-semibold">
                    <td className="border border-gray-300 px-2 md:px-4 py-2">TOTAL GERAL</td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.matriculados, 0)}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.presentes, 0)}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center font-semibold text-purple-600">
                      {(() => {
                        const totalMatriculados = attendanceDataOrdenado.reduce((sum, row) => sum + row.matriculados, 0);
                        const totalPresentes = attendanceDataOrdenado.reduce((sum, row) => sum + row.presentes, 0);
                        return totalMatriculados > 0 ? ((totalPresentes / totalMatriculados) * 100).toFixed(1).replace('.', ',') : '0,0';
                      })()}%
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.ausentes, 0)}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.visitantes, 0)}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.pos_chamada, 0)}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      R$ {attendanceDataOrdenado.reduce((sum, row) => sum + row.total_ofertas, 0).toFixed(2).replace('.', ',')}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.total_biblias, 0)}
                    </td>
                    <td className="border border-gray-300 px-2 md:px-4 py-2 text-center">
                      {attendanceDataOrdenado.reduce((sum, row) => sum + row.total_revistas, 0)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Classes Vencedoras */}
        <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Classes Vencedoras por Departamento</h2>

          {Object.keys(classesVencedoras).length === 0 ? (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
              <p className="text-yellow-800 text-lg mb-3">
                ⚙️ Nenhuma configuração de departamentos encontrada
              </p>
              <p className="text-yellow-700 text-sm mb-4">
                Para visualizar as classes vencedoras, você precisa configurar os departamentos e turmas primeiro.
              </p>
              <button
                onClick={() => setCurrentView('config-departamentos')}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Configurar Departamentos
              </button>
            </div>
          ) : (
            <div className="space-y-6">
              {Object.keys(classesVencedoras).map((dept, index) => {
                const cores = [
                  { bg: 'bg-green-50', border: 'border-green-200', title: 'text-green-700', text: 'text-green-800', value: 'text-green-700' },
                  { bg: 'bg-blue-50', border: 'border-blue-200', title: 'text-blue-700', text: 'text-blue-800', value: 'text-blue-700' },
                  { bg: 'bg-purple-50', border: 'border-purple-200', title: 'text-purple-700', text: 'text-purple-800', value: 'text-purple-700' },
                  { bg: 'bg-orange-50', border: 'border-orange-200', title: 'text-orange-700', text: 'text-orange-800', value: 'text-orange-700' },
                  { bg: 'bg-pink-50', border: 'border-pink-200', title: 'text-pink-700', text: 'text-pink-800', value: 'text-pink-700' },
                ];
                const cor = cores[index % cores.length];

                return (
                  <div key={dept} className="space-y-4">
                    <h3 className={`text-lg font-medium ${cor.title} border-b-2 ${cor.border} pb-2`}>
                      Departamento {dept}
                    </h3>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                      <div className={`${cor.bg} border ${cor.border} rounded-lg p-4`}>
                        <h4 className={`font-semibold ${cor.text} mb-2 text-sm md:text-base`}>
                          Classe Vencedora em Frequência do departamento {dept}
                        </h4>
                        <p className={`${cor.value} text-sm md:text-base`}>
                          {classesVencedoras[dept]?.frequencia ? (
                            <>
                              Nome: <span className="font-semibold">{classesVencedoras[dept].frequencia.turma_nome}</span> –
                              Porcentagem: <span className="font-semibold">{formatarPorcentagem(classesVencedoras[dept].frequencia.porcentagem)}%</span>
                            </>
                          ) : (
                            'Nenhuma turma encontrada para este departamento'
                          )}
                        </p>
                      </div>

                      <div className={`${cor.bg} border ${cor.border} rounded-lg p-4`}>
                        <h4 className={`font-semibold ${cor.text} mb-2 text-sm md:text-base`}>
                          Classe Vencedora em Oferta do departamento {dept}
                        </h4>
                        <p className={`${cor.value} text-sm md:text-base`}>
                          {classesVencedoras[dept]?.oferta ? (
                            <>
                              Nome: <span className="font-semibold">{classesVencedoras[dept].oferta.turma_nome}</span> –
                              Máximo: <span className="font-semibold">R$ {formatarValor(classesVencedoras[dept].oferta.valor)}</span>
                            </>
                          ) : (
                            'Nenhuma turma encontrada para este departamento'
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Informações Adicionais */}
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <h4 className="font-semibold text-gray-700 mb-2 text-sm md:text-base">Critérios de Classificação:</h4>
            <ul className="text-xs md:text-sm text-gray-600 space-y-1">
              <li>• <strong>Frequência:</strong> Calculada como (Presentes ÷ Matriculados) × 100, arredondada com 2 casas decimais</li>
              <li>• <strong>Oferta:</strong> Baseada no valor total de ofertas da turma, arredondada com 2 casas decimais</li>
              <li>• <strong>Departamentos:</strong> Baseados na posição das turmas (Infantil: primeiras, Jovens: intermediárias, Adulto: últimas)</li>
              <li>• <strong>Lógica Excel:</strong> Equivalente a ÍNDICE + CORRESP + MÁXIMO para encontrar vencedores</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
